<template>
  <div id="screen">
    <el-image class="image-navigation" :src="require('../../src/assets/cockpit/totGd.png')"></el-image>
    <div @click="totalClick" class="title"></div>
    <!--左侧导航-->
    <ul class="left-navigation">
      <li :class="navigationIndex === index ? 'select-style' : ''" @click="navigationClick(index)" v-for="(item,index) in leftNavigation" :key="index">{{item}}</li>
    </ul>
    <!--右侧导航-->
    <ul class="right-navigation">
      <li :class="rightNavigationIndex === index ? 'select-style' : ''" @click="leftNavigationClick(index)" v-for="(item,index) in rightNavigation" :key="index">{{item}}</li>
    </ul>
    <div class="content">
      <jscDiV v-show="total === 0"></jscDiV>
      <el-image style="width: 100%;height:100%" v-show="navigationIndex === 0" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="navigationIndex === 1" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="navigationIndex === 2" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="navigationIndex === 3" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="navigationIndex === 4" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="navigationIndex === 5" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="rightNavigationIndex === 0" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="rightNavigationIndex === 1" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="rightNavigationIndex === 2" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="rightNavigationIndex === 3" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="rightNavigationIndex === 4" :src="require('../assets/cockpit/cockpit.png')"></el-image>
      <el-image style="width: 100%;height:100%" v-show="rightNavigationIndex === 5" :src="require('../assets/cockpit/cockpit.png')"></el-image>
    </div>
  </div>
</template>

<script>
import jscDiV from '../components/cockpitCh/jsc.vue'
export default {
  name: "cockpitCh",
  components:{
      jscDiV
  },
  data() {
    return {
      width: "1920",
      height: "1080",
      transform: "scaleY(1) scaleX(1) translate(-50%, -50%)",
      leftNavigation:['预警','前期','征拆','工程量','进度','投资'],
      rightNavigation:['试验','质量','安全','物资','劳务','监控'],
      navigationIndex:'',
      rightNavigationIndex:'',
      total:0
    }
  },
  mounted() {
    // this.rightNavigationIndex = this.rightNavigation.length - 1;
    let that = this;
    // that.setScale();
    // // 窗口尺寸改变时触发事件
    // window.addEventListener('resize', () => {
    //   that.setScale();
    // })
  },
  methods:{
    navigationClick(index) {
      this.total = 2
      this.navigationIndex = index
      this.rightNavigationIndex = ''
    },
    leftNavigationClick(index) {
      this.total = 2
      this.rightNavigationIndex = index
      this.navigationIndex = ''
    },
    totalClick() {
      this.total = 0
      this.navigationIndex = ''
      this.rightNavigationIndex = ''
    },
    getScale() {
      const w = window.innerWidth / this.width;
      const h = window.innerHeight / this.height;
      return {x:w,y:h};
    },
    setScale() {
      let scale = this.getScale();
      this.transform = "scaleY(" + scale.y + ") scaleX(" + scale.x + ") translate(-50%, -50%)";
    }
  }
}
</script>

<style scoped>
#screen{
  width: 100%;
  height: 100%;
  /*z-index: 100;*/
  /*transform-origin: 0 0;*/
  /*position: fixed;*/
  /*left: 50%;*/
  /*top: 50%;*/
  /*transition: 0.3s;*/
  background-image:url("../../src/assets/cockpit/cockpit.png");
}
.image-navigation {
  width: 100%;
  position: relative;
}
.title {
  width: 420px;
  height: 40px;
  background-color:transparent;
  position: absolute;
  top: 20px;
  left: calc(50% - 200px);
  cursor: pointer;
}
ul,li {
  list-style: none;
  padding: 0;
}
ul {
  display: flex;
  color: #7db0df;
  width: 32%;
  font-weight: bold;
  font-size: 20px;
}
li {
  margin:0 10px;
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 4px solid #063d84;
}
li:hover {
  color: #ffffff;
  border-bottom-color: #ffffff;
}
.select-style {
  color: #ffffff;
  border-bottom-color: #ffffff;
}
.left-navigation {
  position: absolute;
  top: 20px;
  left: 0;
  justify-content:flex-end;
}
.right-navigation {
  position: absolute;
  top: 20px;
  right: 0;
  justify-content: flex-start;
}
.content {
  width: 100%;
  height: calc(100% - 100px);
}

</style>



// WEBPACK FOOTER //
// src/views/cockpitCh.vue